import { EvtHeader } from "components/header";
import React from "react";
import OpeningForm from "../form";

const CreateOpenings = () => {
  return (
    <div className="flex-1">
      <EvtHeader title="Create Openings" />
      <div className="p-6 max-w-md">
        <OpeningForm />
      </div>
    </div>
  );
};

export default CreateOpenings;
